import React from 'react';
import { RepeatIcon, MapPinIcon, TagIcon, ListIcon, BuildingIcon } from 'lucide-react';
const ObligationsList = ({
  obligations,
  attributes,
  onEdit
}) => {
  if (!obligations.length) {
    return <p className="text-gray-500 italic" data-id="element-226">No obligations added yet.</p>;
  }
  const getAttributeName = attributeId => {
    if (!attributeId) return null;
    const attribute = attributes.find(attr => attr.id === attributeId);
    return attribute ? attribute.name : 'Unknown';
  };
  const formatAttributeCondition = condition => {
    if (!condition) return null;
    const attribute = attributes.find(attr => attr.id === condition.attributeId);
    if (!attribute) return null;
    return `${attribute.name} ${condition.operator.toLowerCase()} ${condition.value}`;
  };
  const formatPropertyField = field => {
    if (!field) return null;
    return `${field.field} ${field.operator.toLowerCase()} ${field.value}`;
  };
  return <div className="space-y-4" data-id="element-227">
      {obligations.map(obligation => <div key={obligation.id} className="p-4 border rounded-md hover:bg-gray-50" data-id="element-228">
          <div className="flex justify-between" data-id="element-229">
            <h3 className="font-medium text-gray-900" data-id="element-230">{obligation.name}</h3>
            <button className="text-gray-400 hover:text-gray-500" onClick={() => onEdit(obligation.id)} data-id="element-231">
              <span className="sr-only" data-id="element-232">Edit</span>
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-233">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" data-id="element-234" />
              </svg>
            </button>
          </div>
          <p className="mt-1 text-sm text-gray-500" data-id="element-235">{obligation.description}</p>
          <div className="mt-3 flex flex-col gap-2" data-id="element-236">
            {/* Basic details */}
            <div className="flex flex-wrap gap-2" data-id="element-237">
              {obligation.attributeId && <span className="inline-flex items-center text-xs text-gray-500" data-id="element-238">
                  <TagIcon className="h-3.5 w-3.5 mr-1" data-id="element-239" />
                  {getAttributeName(obligation.attributeId)}
                </span>}
              {obligation.location && <span className="inline-flex items-center text-xs text-gray-500" data-id="element-240">
                  <MapPinIcon className="h-3.5 w-3.5 mr-1" data-id="element-241" />
                  {obligation.location}
                </span>}
              <span className="inline-flex items-center text-xs text-gray-500" data-id="element-242">
                <RepeatIcon className="h-3.5 w-3.5 mr-1" data-id="element-243" />
                {obligation.recurring}
              </span>
              {obligation.responsibleParty && <span className="inline-flex items-center text-xs text-gray-500" data-id="element-244">
                  <BuildingIcon className="h-3.5 w-3.5 mr-1" data-id="element-245" />
                  {obligation.responsibleParty}
                </span>}
            </div>
            {/* Attribute conditions */}
            {obligation.attributeConditions && obligation.attributeConditions.length > 0 && <div className="mt-1" data-id="element-246">
                  <span className="text-xs font-medium text-gray-600" data-id="element-247">
                    Conditions:
                  </span>
                  <ul className="ml-5 mt-1 list-disc text-xs text-gray-500" data-id="element-248">
                    {obligation.attributeConditions.map((condition, idx) => <li key={idx} data-id="element-249">{formatAttributeCondition(condition)}</li>)}
                  </ul>
                  {obligation.attributeConditions.length > 1 && <span className="text-xs text-gray-500 italic ml-5" data-id="element-250">
                      (
                      {obligation.attributeCombination === 'ALL' ? 'All conditions must match' : 'Any condition may match'}
                      )
                    </span>}
                </div>}
            {/* Property fields */}
            {obligation.propertyFields && obligation.propertyFields.length > 0 && <div className="mt-1" data-id="element-251">
                  <span className="text-xs font-medium text-gray-600" data-id="element-252">
                    Property Fields:
                  </span>
                  <ul className="ml-5 mt-1 list-disc text-xs text-gray-500" data-id="element-253">
                    {obligation.propertyFields.map((field, idx) => <li key={idx} data-id="element-254">{formatPropertyField(field)}</li>)}
                  </ul>
                  {obligation.propertyFields.length > 1 && <span className="text-xs text-gray-500 italic ml-5" data-id="element-255">
                      (
                      {obligation.fieldCombination === 'ALL' ? 'All fields must match' : 'Any field may match'}
                      )
                    </span>}
                </div>}
            {/* Locations */}
            {obligation.locationFields && obligation.locationFields.length > 0 && <div className="mt-1" data-id="element-256">
                  <span className="text-xs font-medium text-gray-600" data-id="element-257">
                    Locations:
                  </span>
                  <ul className="ml-5 mt-1 list-disc text-xs text-gray-500" data-id="element-258">
                    {obligation.locationFields.map((location, idx) => <li key={idx} data-id="element-259">{location}</li>)}
                  </ul>
                  {obligation.locationFields.length > 1 && <span className="text-xs text-gray-500 italic ml-5" data-id="element-260">
                      (
                      {obligation.locationCombination === 'ALL' ? 'All locations must match' : 'Any location may match'}
                      )
                    </span>}
                </div>}
          </div>
        </div>)}
    </div>;
};
export default ObligationsList;